import { FC, Fragment, PropsWithChildren } from 'react';

import { MovableInkPanel } from 'modules/movableInk';
import { useModalContext } from 'utils/contexts/modal';

import { Modals } from '../../types';
import { useSideBySideEditorContext } from '../SideBySideEditorContext';

export const MovableInkContextProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { editor, selectedImage, selectedAnchor } = useSideBySideEditorContext();
  const { modalState, hideModal } = useModalContext<Modals>();

  const handleAssetInsert = (
    imgAttrs: Record<string, string>,
    linkAttrs: Record<string, string>,
  ) => {
    const thisEditor = editor.current;
    if (thisEditor) {
      const target = thisEditor.selection.getRange(); // either the cursor location or selected range
      const imgAttrStr = Object.keys(imgAttrs)
        .reduce((attrPairs: string[], attrKey: string) => {
          // @ts-ignore
          const attrValue = imgAttrs[attrKey].trim().replaceAll('"', '&quot;');
          if (attrValue) {
            attrPairs.push(`${attrKey}="${attrValue}"`);
          }
          return attrPairs;
        }, [])
        .join(' ');
      const linkAttrStr = Object.keys(linkAttrs)
        .reduce((attrPairs: string[], attrKey: string) => {
          // @ts-ignore
          const attrValue = linkAttrs[attrKey].trim().replaceAll('"', '&quot;');
          if (attrValue) {
            attrPairs.push(`${attrKey}="${attrValue}"`);
          }
          return attrPairs;
        }, [])
        .join(' ');
      const eltHtml = linkAttrs?.href
        ? `<a ${linkAttrStr}><img ${imgAttrStr} /></a>`
        : `<img ${imgAttrStr} />`;
      const newElementRange = {
        ...target,
        end: { row: target.end.row, column: target.start.column + eltHtml.length },
      };
      thisEditor.session.replace(target, eltHtml);
      thisEditor.selection.setRange(newElementRange);
      thisEditor.focus();
    }
  };

  return (
    <Fragment>
      {modalState === Modals.MovableInk && (
        <MovableInkPanel
          onClose={hideModal}
          onInsert={handleAssetInsert}
          selectedEditorImageNode={selectedImage}
          selectedEditorImageAnchorNode={selectedAnchor}
        />
      )}
      {children}
    </Fragment>
  );
};
